<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                '平台ID/平台名称/平台账户/渠道ID/渠道名称/模板 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditDialog', { type: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      :modal-append-to-body="false"
      :modal="false"
    >
      <el-form ref="form" :model="form" size="mini">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="'状态'">
              <el-checkbox-group v-model="form.listStatus">
                <el-checkbox label="Y">
                  {{ '已启用' }}
                </el-checkbox>
                <el-checkbox label="D">
                  {{ '已删除' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="'平台'">
              <dict-select
                v-model="form.listPlatformId"
                url="/ecomorder/ecom/platform/select/platform"
                :placeholder="'请选择平台'"
                clearable
                filterable
                multiple
                style="width:100%"
                size="mini"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="'平台账户'">
              <dict-select
                v-model="form.listPlatformAccountCode"
                url="/ecomorder/ecom/platform/select/account"
                :placeholder="'请选择平台账户'"
                clearable
                filterable
                multiple
                style="width:100%"
                size="mini"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="'销售渠道'">
              <dict-select
                v-model="form.listSalesChannelId"
                url="/ecomorder/ecom/platform/select/evgPlatform"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                clearable
                filterable
                multiple
                style="width:100%"
                size="mini"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.table_label_created_date') || '创建时间'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createStartTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createEndTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyStartTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyEndTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '', listStatus: ['Y', 'N'] }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
